import axios from 'axios';

export interface BulkAssignSupraLockboxForSingleUserResult {
  successfulIds: string[];
  failedIds: string[];
  failedIdsWithErrors?: { id: string; errorMessage: string }[];
  successCount: number;
  failureCount: number;
}

const bulkAssignSupraLockboxForSingleUser = async ({
  userId,
  lockboxIds,
  permissions,
  granteeUserIds = [],
  grantOfficeShacklePermissions,
}: {
  userId: string;
  lockboxIds: string[];
  permissions: {
    permissionType: 'owner' | 'assignee';
    ownerOrAssigneeType: 'user' | 'office';
    branchIndex: string | null;
  };
  granteeUserIds?: string[];
  grantOfficeShacklePermissions?: boolean;
}): Promise<BulkAssignSupraLockboxForSingleUserResult> => {
  const { data, status } =
    await axios.post<BulkAssignSupraLockboxForSingleUserResult>(
      '/supra/lockbox/bulk_assign_user',
      {
        userId,
        lockboxIds,
        permissions,
        granteeUserIds,
        grantOfficeShacklePermissions,
      },
    );

  if (status < 200 || status >= 300) {
    throw new Error(`Unexpected response status: ${status}`);
  }

  return data;
};

export default bulkAssignSupraLockboxForSingleUser;
